<template>
  <div>
    <div class="space-y-4">
      <div>
        <h2 class="font-semibold text-gray-600">
          <span class="uppercase">Ride</span> -
          {{ this.ride ? this.ride._id : "" }}
        </h2>
      </div>
      <hr />
      <div class="inline-block min-w-full -lg mt-4" v-if="!loading">
        <div class="flex" v-if="ride != null">
          <div class="w-1/5">
            <h2 class="font-semibold text-gray-600 uppercase">Driver</h2>
            <div v-if="ride.driver">
              <p>{{ ride.driver.firstName + " " + ride.driver.lastName }}</p>
              <p>{{ ride.driver.phoneNumber }}</p>
            </div>
          </div>
          <div class="w-1/5">
            <h2 class="font-semibold text-gray-600 uppercase">Passenger</h2>
            <div v-if="ride.passenger">
              <p>
                {{ ride.passenger.firstName + " " + ride.passenger.lastName }}
              </p>
              <p>{{ ride.passenger.phoneNumber }}</p>
            </div>
          </div>
          <div class="w-1/5">
            <h2 class="font-semibold text-gray-600 uppercase">Dispatcher</h2>
            <div v-if="ride.dispatcher">
              <p>
                {{ ride.dispatcher.firstName + " " + ride.dispatcher.lastName }}
              </p>
            </div>
          </div>
          <div class="w-1/5">
            <h2 class="font-semibold text-gray-600 uppercase">vehicle type</h2>
            <div v-if="ride.vehicleType">
              <p>{{ ride.vehicleType.name }}</p>
            </div>
          </div>
          <div class="w-1/5">
            <h2 class="font-semibold text-gray-600 uppercase">vehicle</h2>
            <div v-if="ride.vehicle">
              <p>{{ ride.vehicle.color + " " + ride.vehicle.modelName }}</p>
              <p>{{ ride.vehicle.plateNumber }}</p>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="flex" v-if="ride != null">
        <div class="w-1/5">
          <h2 class="font-semibold text-gray-600 uppercase">Corporate</h2>
          <div>
            <p>{{ ride.corporate ? ride.corporate : false }}</p>
          </div>
        </div>
        <div class="w-1/5">
          <h2 class="font-semibold text-gray-600 uppercase">Ticket</h2>
          <div>
            <p>{{ ride.ticket ? ride.ticket.key : "" }}</p>
          </div>
        </div>
        <div class="w-1/5">
          <h2 class="font-semibold text-gray-600 uppercase">Status</h2>
          <div>
            <p>{{ ride.status }}</p>
          </div>
        </div>
        <div class="w-1/5">
          <h2 class="font-semibold text-gray-600 uppercase">Type</h2>
          <div>
            <p>{{ ride.type }}</p>
          </div>
        </div>
        <div class="w-1/5">
          <h2 class="font-semibold text-gray-600 uppercase">Active</h2>
          <div>
            <p>{{ ride.active }}</p>
          </div>
        </div>
      </div>
      <hr />
      <div class="flex">
        <div class="w-1/4 mr-4" v-if="ride != null">
          <div>
            <div class="justify-between items-center border-b py-2">
              <h2 class="font-semibold text-gray-600 uppercase">From</h2>
              <div>
                <p>{{ ride.pickUpAddress.name }}</p>
              </div>
            </div>
            <div class="justify-between items-center border-b py-2">
              <h2 class="font-semibold text-gray-600 uppercase">To</h2>
              <div>
                <p>{{ ride.dropOffAddress.name }}</p>
              </div>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Cancel cost</span>
              <span> {{ ride.cancelCost.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Company cut</span>
              <span>{{ ride.companyCut.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Fare</span>
              <span>{{ ride.fare.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Tax</span>
              <span>{{ ride.tax.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Discount</span>
              <span>{{ ride.discount.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Paid to driver</span>
              <span>{{ ride.payedToDriver.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Net</span>
              <span>{{ ride.net.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center border-b py-2">
              <span>Collect from driver</span>
              <span>{{ ride.collectFromDriver }}</span>
            </div>
          </div>
        </div>
        <div class="w-full">
          <div
            class="bg-teal-600 w-full h-full rounded-lg shadow overflow-hidden"
            ref="map"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import init from "@/gmaps";
export default {
  data() {
    return {
      ride: null,
      loading: true,
      google: null,
      markers: [],
      map: null
    };
  },
  watch: {},
  created() {
    this.getRide();
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  async mounted() {
    this.google = await init();

    this.map = new this.google.maps.Map(this.$refs.map, {
      center: {
        lat: 9.004912,
        lng: 38.778282
      },
      zoom: 13
    });
  },
  methods: {
    getRide() {
      this.loading = true;
      var path = `trips/${this.id}?limit=populate=["driver","passenger","vehicleType","dispatcher"]`;
      this.$http
        .get(path)
        .then(response => {
          this.ride = response.data;
          console.log(this.ride);

          if (this.ride.path && this.ride.path.length > 1) {
            new this.google.maps.Marker({
              position: {
                lat: this.ride.path[0][1],
                lng: this.ride.path[0][0]
              },
              icon: {
                path:
                  "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
                fillColor: "#00FF00",
                fillOpacity: 1.0,
                strokeColor: "#000000",
                strokeWeight: 2,
                scale: 2,
                anchor: new this.google.maps.Point(12, 24)
              },
              map: this.map
            });

            new this.google.maps.Marker({
              position: {
                lat: this.ride.path[this.ride.path.length - 1][1],
                lng: this.ride.path[this.ride.path.length - 1][0]
              },
              icon: {
                path:
                  "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
                fillColor: "#ff0000",
                fillOpacity: 1.0,
                strokeColor: "#000000",
                strokeWeight: 2,
                scale: 2,
                anchor: new this.google.maps.Point(12, 24)
              },
              map: this.map
            });
          }

          new this.google.maps.Marker({
            position: {
              lat: this.ride.pickUpAddress.coordinate.lat,
              lng: this.ride.pickUpAddress.coordinate.long
            },
            icon: {
              path:
                "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
              fillColor: "#00FF00",
              fillOpacity: 1.0,
              strokeColor: "#000000",
              strokeWeight: 1,
              scale: 1,
              anchor: new this.google.maps.Point(12, 24)
            },
            map: this.map
          });

          new this.google.maps.Marker({
            position: {
              lat: this.ride.dropOffAddress.coordinate.lat,
              lng: this.ride.dropOffAddress.coordinate.long
            },
            icon: {
              path:
                "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
              fillColor: "#ff0000",
              fillOpacity: 1.0,
              strokeColor: "#000000",
              strokeWeight: 1,
              scale: 1,
              anchor: new this.google.maps.Point(12, 24)
            },
            map: this.map
          });

          var route = this.ride.route.coordinates.map(coord => {
            return { lat: coord[1], lng: coord[0] };
          });

          new this.google.maps.Polyline({
            path: route,
            geodesic: true,
            map: this.map,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2
          });

          var path = this.ride.path.map(coord => {
            return { lat: coord[1], lng: coord[0] };
          });

          new this.google.maps.Polyline({
            path: path,
            geodesic: true,
            map: this.map,
            strokeColor: "#00FF00",
            strokeOpacity: 1.0,
            strokeWeight: 2
          });

          this.$http
            .get(`trips/${this.id}/sos`)
            .then(sos => {
              if (sos.data && sos.data.length) {
                var icon = "https://res.cloudinary.com/torpa/image/upload/w_20,h_20/v1598222724/important-icon-png-26_xte9of.png";
                sos.data.forEach(element => {
                  this.$http.patch(`sos/${element._id}`, {active: false})

                  new this.google.maps.Marker({
                    position: {
                      lat: element.position.coordinates[1],
                      lng: element.position.coordinates[0]
                    },
                    icon,
                    map: this.map
                  });
                });
              }
            })
            .catch(error => {
              console.log({ error });
            });
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
